import { Node } from 'prosemirror-model'
import { EditorView, NodeView } from 'prosemirror-view'
import Styles from '../OutlineEditor.module.scss'
import { indentBy } from '../commands/indentBy'
import { Selection } from 'prosemirror-state'
import { icons } from './icons'

export class HeadingView implements NodeView {
  node: Node
  dom: HTMLElement
  view: EditorView
  getPos: () => number
  contentDOM: HTMLElement

  constructor(node: Node, view: EditorView, getPos: () => number) {
    this.node = node
    this.view = view
    this.getPos = getPos
    this.dom = document.createElement(`h${node.attrs.level}`)

    const level = this.node.attrs.level as 2 | 3

    const icon = document.createElement('div')
    const tag: 'h2' | 'h3' = `h${level}`
    icon.innerHTML = icons[tag]
    icon.classList.add(Styles.icon)
    this.dom.appendChild(icon)

    icon.addEventListener('click', (e) => {
      e.preventDefault()
      const $pos = view.state.doc.resolve(this.getPos())
      const tr = view.state.tr
      tr.setSelection(new Selection($pos, $pos))
      view.dispatch(view.state.tr)
      indentBy(this.node.attrs.level === 3 ? -1 : 1)(view.state, view.dispatch)
    })

    this.contentDOM = document.createElement('span')
    this.contentDOM.classList.add(Styles.text)
    this.dom.appendChild(this.contentDOM)
  }
}
